module.exports = __webpack_public_path__ + "img/id_f.17cde46b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/id_f.png
// module id = zqwl
// module chunks = 1